import { useContactHeroContent } from '../../../../hooks/useContactHeroContent';
import heroImage from '../../../../assets/images/contact/hero/hero.jpg';
import './Hero.css';

const Hero = () => {
  const { content, isLoading } = useContactHeroContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text, image } = content;

  return (
    <section className="contact-hero">
      <img
        className="contact-hero__bg"
        src={image || heroImage}
        alt=""
        aria-hidden="true"
      />
      <div className="contact-hero__overlay" />

      <div className="contact-hero__inner">
        <div className="contact-hero__content">
          {eyebrow ? <p className="contact-hero__eyebrow">{eyebrow}</p> : null}
          <h1 className="contact-hero__title">{title}</h1>
          {text ? <p className="contact-hero__text">{text}</p> : null}
        </div>
      </div>
    </section>
  );
};

export default Hero;
